module.exports = __webpack_public_path__ + "img/align-center.5d401424.svg";